module.exports = __webpack_public_path__ + "img/career-portraits.b56f4f07.jpg";